<template>
  <div class="wrapper">
    <slot></slot>
  </div>
</template>
<style type="text/css">


</style>
<script type="text/javascript">
    import sidebar from './sidebar'
    export default {
        data() {
            return {}
        },
        mounted() {},
        methods: {},
        components: {
            'l-sidebar': sidebar,
        }
    }
</script>


// WEBPACK FOOTER //
// wrapper.vue?0871e95e